import { httpsCallable } from "firebase/functions";
import { functions } from "@/base";

// eslint-disable-next-line import/no-unused-modules
export interface CreateLicenciadaRequest {
  novaLicenciada: unknown;
  novaEmpresa: unknown;
  template: {
    licenciadaId: string;
    empresaId: string;
    collections: string[];
  };
  admin: {
    nome: string;
    email: string;
    telefone: string;
  };
}

// eslint-disable-next-line import/no-unused-modules
export interface CreateLicenciadaResponse {
  licenciadaId: string;
  empresaId: string;
  adminUid: string;
  cloneResults: {
    tiposDeRespostas: { count: number };
    questionarios: { count: number };
    gruposDiagnostico: { count: number };
    perguntas: { count: number };
  };
}

/**
 * Calls the cloud function to create a new licenciada with empresa and clone template data
 * @param data
 */
export const createLicenciadaWithEmpresa = async (data: CreateLicenciadaRequest): Promise<CreateLicenciadaResponse> => {
  const callable = httpsCallable<CreateLicenciadaRequest, CreateLicenciadaResponse>(
    functions,
    "licenciadasFunctions-createLicenciadaWithEmpresa"
  );

  const result = await callable(data);
  return result.data;
};
